import WhiteLogo from "../images/White_Orange_Logo.svg";
import BlackLogo from "../images/Black_Orange_Logo.svg";

export const companyLogoWhite = WhiteLogo;
export const companyLogoBlack = BlackLogo;
